module.exports = __webpack_public_path__ + "img/logo-maprochaineauto.58e7a659.png";